import createSvgIcon from 'shared/utils/createSvgIcon';

export default createSvgIcon(
  <path
    xmlns="http://www.w3.org/2000/svg"
    d="M-18.158-363.871v20.385a.481.481,0,0,0,.481.481H-1.716a.48.48,0,0,0,.481-.481v-20.385a.48.48,0,0,0-.481-.48H-17.677A.481.481,0,0,0-18.158-363.871Zm14.064,10.766H-15.3v-1.654H-4.094Zm0,3.837H-15.3v-1.654H-4.094Zm0,3.695H-15.3v-1.654H-4.094Z"
    transform="translate(18.158 364.352)"
  />,
  '0 0 16.923 21.346'
);
